export const portfolioImages = {
  logos: [
    { src: '/assets/portfolio/logos/aamedsa-logo.jpg', title: 'Aamedsa - Logotipo', category: 'logos' },
    { src: '/assets/portfolio/logos/asug.jpg', title: 'Asug - Identidade Visual', category: 'logos' },
    { src: '/assets/portfolio/logos/cca_cores_logo.jpg', title: 'CCA Cores - Logo', category: 'logos' },
    { src: '/assets/portfolio/logos/consmaster.jpg', title: 'Consmaster - Logotipo', category: 'logos' },
    { src: '/assets/portfolio/logos/consultare.jpg', title: 'Consultare - Identidade', category: 'logos' },
    { src: '/assets/portfolio/logos/dale.jpg', title: 'Dale - Logotipo', category: 'logos' },
    { src: '/assets/portfolio/logos/davi.jpg', title: 'Davi - Identidade Visual', category: 'logos' },
    { src: '/assets/portfolio/logos/dnq.jpg', title: 'DNQ - Logotipo', category: 'logos' },
    { src: '/assets/portfolio/logos/ehbeleza.jpg', title: 'Eh Beleza - Logo', category: 'logos' },
    { src: '/assets/portfolio/logos/giraclub.jpg', title: 'Gira Club - Identidade', category: 'logos' },
    { src: '/assets/portfolio/logos/girafesta.jpg', title: 'Gira Festa - Logo', category: 'logos' },
    { src: '/assets/portfolio/logos/globatis.jpg', title: 'Globatis - Logotipo', category: 'logos' },
    { src: '/assets/portfolio/logos/khris.jpg', title: 'Khris - Identidade Visual', category: 'logos' },
    { src: '/assets/portfolio/logos/logo_aggregare_10cm.jpg', title: 'Aggregare - Logo', category: 'logos' },
    { src: '/assets/portfolio/logos/maxrol.jpg', title: 'Maxrol - Logotipo', category: 'logos' },
    { src: '/assets/portfolio/logos/officer.jpg', title: 'Officer - Identidade', category: 'logos' },
    { src: '/assets/portfolio/logos/rs.jpg', title: 'RS - Logotipo', category: 'logos' },
    { src: '/assets/portfolio/logos/santa.jpg', title: 'Santa - Logo', category: 'logos' },
    { src: '/assets/portfolio/logos/viva_leve.jpg', title: 'Viva Leve - Identidade', category: 'logos' }
  ],

  paper: [
    { src: '/assets/portfolio/paper/apresentacao-gsgabriel.jpg', title: 'GS Gabriel - Apresentação', category: 'paper' },
    { src: '/assets/portfolio/paper/claure-papelaria.jpg', title: 'Claure - Papelaria Corporativa', category: 'paper' },
    { src: '/assets/portfolio/paper/consmaster-papelaria.jpg', title: 'Consmaster - Papelaria', category: 'paper' },
    { src: '/assets/portfolio/paper/df-papelaria.jpg', title: 'DF - Materiais Corporativos', category: 'paper' },
    { src: '/assets/portfolio/paper/khris-papelaria.jpg', title: 'Khris - Papelaria', category: 'paper' },
    { src: '/assets/portfolio/paper/pid-papelaria.jpg', title: 'PID - Papelaria Corporativa', category: 'paper' }
  ],

  ebooks: [
    { src: '/assets/portfolio/ebooks/an77-apresentacao.jpg', title: 'AN77 - Apresentação', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/asug-emails.jpg', title: 'ASUG - Email Marketing', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/asug-emails2.jpg', title: 'ASUG - Campanha Email 2', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/cartilha-apresentacao.jpg', title: 'Cartilha - Apresentação', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/cengage-email.jpg', title: 'Cengage - Email Marketing', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/ibm-catalogo.jpg', title: 'IBM - Catálogo Digital', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/pid-papelaria.jpg', title: 'PID - Material Digital', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/ssm28-apresentacao.jpg', title: 'SSM28 - Apresentação', category: 'ebooks' },
    { src: '/assets/portfolio/ebooks/vmw05-apresentacao.jpg', title: 'VMW05 - Apresentação', category: 'ebooks' }
  ],

  posts: [
    { src: '/assets/portfolio/posts/apresentacao-ppt.jpg', title: 'Apresentação PPT', category: 'posts' },
    { src: '/assets/portfolio/posts/apresentacao.jpg', title: 'Slide de Apresentação', category: 'posts' },
    { src: '/assets/portfolio/posts/posts1.jpg', title: 'Post para Redes Sociais 1', category: 'posts' },
    { src: '/assets/portfolio/posts/posts2.jpg', title: 'Post para Redes Sociais 2', category: 'posts' },
    { src: '/assets/portfolio/posts/posts3.jpg', title: 'Post para Redes Sociais 3', category: 'posts' },
    { src: '/assets/portfolio/posts/posts4.jpg', title: 'Post para Redes Sociais 4', category: 'posts' }
  ],

  events: [
    { src: '/assets/portfolio/events/caap-ident.jpg', title: 'CAAP - Identidade Visual', category: 'events' },
    { src: '/assets/portfolio/events/cengage-apres.jpg', title: 'Cengage - Apresentação', category: 'events' },
    { src: '/assets/portfolio/events/claure-embal.jpg', title: 'Claure - Embalagens', category: 'events' },
    { src: '/assets/portfolio/events/consultare-cv.jpg', title: 'Consultare - Comunicação Visual', category: 'events' },
    { src: '/assets/portfolio/events/evento1.jpg', title: 'Material para Evento 1', category: 'events' },
    { src: '/assets/portfolio/events/evento2.jpg', title: 'Material para Evento 2', category: 'events' },
    { src: '/assets/portfolio/events/evento3.jpg', title: 'Material para Evento 3', category: 'events' },
    { src: '/assets/portfolio/events/evento4.jpg', title: 'Material para Evento 4', category: 'events' },
    { src: '/assets/portfolio/events/girafesta-cv.jpg', title: 'Gira Festa - Comunicação Visual', category: 'events' },
    { src: '/assets/portfolio/events/sorojet-displays.jpg', title: 'Sorojet - Displays', category: 'events' }
  ]
};

export const getAllImages = () => {
  return Object.values(portfolioImages).flat();
};